module.exports = __webpack_public_path__ + "static/slithering_tracker-7d68f645603d37809f3223a7df2ccca9.jpeg";